import { $$ } from 'utils/dom';
import { Modal } from '@3pc/modal-dialog';

const modal = $$('.modal-search__content');

if (modal.length) {
  modal.forEach(modal => {
    const openBtns = $$('[data-modal-open]', modal.parentElement);
    new Modal({
      modal,
      modalOpenBtns: openBtns,
      modalCloseBtns: $$('[data-modal-close]', modal),
      onOpen: openBtn => {
        document.querySelector('body').classList.add('modal-is-open');
      },
      onClose: closeBtn => {
        document.querySelector('body').classList.remove('modal-is-open');
      },
    }).init();
  });
}
